import Vue from 'vue';

Vue.filter('currency', function(value: any){
    if(typeof value !== "number"){
        return value;
    }
    var formatter = new Intl.NumberFormat('es-CO', {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 2
    });
    return formatter.format(value)
});